export const OPTIN_MODES = {
  PAGES_VIEWED: "pages_viewed",
  SECOND_PAGE: "second_page",
  PAGE_NUMBER: "page_number",
};

export const DEFAULT_OPTIN_AFTER_PAGES = 2;

export const DEFAULT_OPTIN_HEADLINE = "{{sender_first_name}} shared this with you for a reason";

export const OPTIN_NOT_A_MAILING_LIST = "This isn't a mailing list.";

export const CURRENT_OPTIN_COPY_VERSION = 2;

export const OPTIN_COPY = {
  1: {
    benefit:
      "Your choices so far have taken you straight to what's relevant, so you don't have to read everything cover to cover to find it. We're trying to save you time.",
    disclosure:
      "Share your name and work email with {{sender_company}} so they can follow up with you.",
    mailingInline: false,
    fieldsLabel: null,
    footer: "Your details go to {{sender_company}} only. You can ask them to delete them at any time.",
  },
  2: {
    benefit:
      "Your choices so far have taken you straight to what's relevant, so you don't have to read everything cover to cover. We're trying to save you time.",
    disclosure:
      "{{sender_company}} receives your name and email so they can follow up with you.",
    mailingInline: true,
    fieldsLabel: "Please enter your:",
    footer: "Only {{sender_company}} receives your details. Deleted on request.",
  },
};

export const getOptInCopy = (optIn) =>
  OPTIN_COPY[Number(optIn?.optin_copy_version)] || OPTIN_COPY[CURRENT_OPTIN_COPY_VERSION];

export const DEFAULT_OPTIN_BENEFIT = OPTIN_COPY[CURRENT_OPTIN_COPY_VERSION].benefit;

export const OPTIN_MARKETING_LABEL = "Send me occasional updates from {{sender_company}}";

export const OPTIN_MESSAGES = {
  invalidEmail: "Enter a work email, like name@company.com.",
  emptyName: "Add your first name so {{sender_company}} knows who to follow up with.",
  submitted: "Thanks, {{first_name}}. Carry on.",
  failed: "Something went wrong. Please try again.",
};

const optInCopyVersion = (optIn) =>
  OPTIN_COPY[Number(optIn?.optin_copy_version)] ? Number(optIn.optin_copy_version) : CURRENT_OPTIN_COPY_VERSION;

const plainText = (html) =>
  String(html || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&(#39|#039|rsquo|apos);/g, "'")
    .replace(/[‘’]/g, "'")
    .replace(/\s+/g, " ")
    .trim();

const DEFAULT_BENEFITS = Object.values(OPTIN_COPY).map((copy) => plainText(copy.benefit));

export const isDefaultOptInBenefit = (html) => !plainText(html) || DEFAULT_BENEFITS.includes(plainText(html));

export const isDefaultOptInHeadline = (headline) => {
  const text = (headline || "").trim();
  return !text || text === DEFAULT_OPTIN_HEADLINE;
};

export const getStandardOptInText = (optIn, strings) => {
  const base = getOptInCopy(optIn);
  const local = strings?.[`v${optInCopyVersion(optIn)}`] || {};
  const pick = (key, fallback) => strings?.[key] || fallback;
  return {
    ...base,
    benefit: local.benefit || base.benefit,
    disclosure: local.disclosure || base.disclosure,
    footer: local.footer || base.footer,
    fieldsLabel: base.fieldsLabel ? pick("fields_label", base.fieldsLabel) : null,
    headline: pick("headline", DEFAULT_OPTIN_HEADLINE),
    notMailingList: pick("not_mailing_list", OPTIN_NOT_A_MAILING_LIST),
    marketingLabel: pick("marketing_label", OPTIN_MARKETING_LABEL),
    firstName: pick("first_name", "First name"),
    lastName: pick("last_name", "Last name"),
    email: pick("email", "Work email"),
    telephone: pick("telephone", "Tel nr."),
    telephoneLabel: pick("telephone_label", "Telephone number"),
    continueLabel: pick("continue", "Continue"),
    skip: pick("skip", "Continue without sharing"),
    privacyNotice: pick("privacy_notice", "Privacy Notice"),
    invalidEmail: pick("invalid_email", OPTIN_MESSAGES.invalidEmail),
    emptyName: pick("empty_name", OPTIN_MESSAGES.emptyName),
    submitted: pick("submitted", OPTIN_MESSAGES.submitted),
    failed: pick("failed", OPTIN_MESSAGES.failed),
  };
};

export const KINETIZINE_PRIVACY_URL = "https://kinetizine.com/privacy";
